import { moneyFormatter, SignOptions, FormatRule } from '@utex/ui-kit';

interface MoneyFormatter {
  sign?: SignOptions;
  rule?: FormatRule;
  locale?: string;
  money: { value: number; currency: string };
}

export const useMoneyFormatter = (opts: MoneyFormatter) => {
  return moneyFormatter({ ...opts });
};
